import script from "./reqList.vue?vue&type=script&setup=true&name=reqList&lang=js"
export * from "./reqList.vue?vue&type=script&setup=true&name=reqList&lang=js"

const __exports__ = script;

export default __exports__